import './index.scss';
import store from '../store';
import YoutubePlayer from './youtubeplayer';
const handleOrientationChange = () => {
  if (store('nowPlayingList').length < 1) return;

  if (window.orientation) {
    store(_.last(store('nowPlayingList'))).handleFullScreenStart();
    $('html, body').removeClass('promokit-landscape--active');
    $('.promokit-landscape').removeClass('promokit-landscape--active');
  }
  else {
    store(_.last(store('nowPlayingList'))).handleFullScreenEnd();
  }
};

if (store('isMobile')) {
  if (store('os') === 'android') {
    window.screen.orientation.onchange = handleOrientationChange;
  }
  else {
    window.addEventListener('orientationchange', handleOrientationChange);
  }
}

export default config => new YoutubePlayer(config)
